import Http from '@/libs/http/request'

/**
 * 检查用户token状态，是否被挤掉
 * @returns 
 */
export const checkTokenStatus = () => {
  return Http.request({
    url: '/v1/user/checkWebAi',
    apiType: 'app',
    showError: false,
    method: 'get'
  })
}

/**
 * 意见反馈
 * @param {*} data 
 * @returns 
 */
export const feedback = data => {
  return Http.request({
    url: '/v1/common/feedback',
    data,
    apiType: 'app',
    showError: false,
    method: 'post'
  })
}

/**
 * 
 * @param {Object} data 
 * @property {String} fileType 文件类型：
                                org：原始文档，对文案存储安全性要求高
                                tmp：临时文档，对文档的安全性要求不高
 * @returns 
 */
export const getOssCredentials = params => {
  return Http.request({
    url: '/v1/file/ossCredentials',
    params,
    apiType: 'app',
    showError: false,
    method: 'get'
  })
}

/**
 * 上传文件前获取临时上传路径和ID
 * @param {Object} data 
 * @property {String} dir: feedback
 * @property {String} fileName: 本地文件名
 * @returns 
 */
export const ossTmpUpload = data => {
  return Http.request({
    url: '/v1/file/ossTmpUpload',
    data,
    apiType: 'app',
    showError: false,
    method: 'post'
  })
}

/**
 * 文件上传完成接口
 * @param {*} fileId 文件ID
 * @returns 
 */
export const ossUploadComplete = fileId => {
  return Http.request({
    url: `/v1/file/ossUploadComplete/${fileId}`,
    apiType: 'app',
    showError: false,
    method: 'post'
  })
}
